/*
  ol-glanz - vier kleine Zugaben, die auf dem GANZEN Shop wirken.

    1  Karten kippen leicht zum Zeiger (nur Maus, nur Desktop)
    2  (entfaellt - Lichtstreifen ueber dem Produktbild, am 20.09.
       entfernt; die Begruendung steht in sections/ol-glanz.liquid)
    3  Wellenschlag auf den grossen Schaltflaechen
    4  Der Reitertitel spricht den Besucher an, wenn er den Tab verlaesst
    5  (frei - der eigene Zeiger ist jetzt reines CSS)
    6  Milchglas in der Kopfleiste, sobald gescrollt wird
    7  Ein duenner Balken zeigt an, dass die naechste Seite kommt

  Regeln, an die sich alles hier haelt:
    * Nichts davon traegt Inhalt. Faellt das Skript aus, fehlt kein Wort.
    * "prefers-reduced-motion" schaltet 1 und 3 ab.
    * Auf Touchgeraeten laeuft 1 gar nicht erst an - dort gibt es
      keinen Zeiger, und die Rechenarbeit waere verschenkt.
    * Kein Layoutversatz: gekippt wird mit transform.
*/
(function () {
  var traeger = document.querySelector('[data-ol-glanz]');
  var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var zeiger = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ------------------------------------------------------------------ 1
     Kippen. Der Wert geht als CSS-Variable raus - das Zeichnen erledigt
     der Browser.

     Hier wurde bis zum 20.09. im selben Durchgang auch der
     Lichtstreifen gerechnet (--ol-licht-x / --ol-licht-y). Er ist samt
     CSS entfernt, weil das wandernde Produktfoto den Inhaber gestoert
     hat; die ausfuehrliche Begruendung steht in
     sections/ol-glanz.liquid. Bitte nicht wieder einbauen. */
  if (zeiger && !ruhig) {
    var karten = document.querySelectorAll('.bsfa-kat__karte, .ol-finder__karte, .bsfa-cf__card');
    Array.prototype.forEach.call(karten, function (karte) {
      var laeuft = false;
      var mx = 0, my = 0;

      function zeichnen() {
        laeuft = false;
        var r = karte.getBoundingClientRect();
        if (!r.width || !r.height) return;
        var x = (mx - r.left) / r.width;
        var y = (my - r.top) / r.height;
        /* Hoechstens drei Grad. Mehr sieht nach Spielzeug aus. */
        karte.style.setProperty('--ol-kipp-x', ((0.5 - y) * 3).toFixed(2) + 'deg');
        karte.style.setProperty('--ol-kipp-y', ((x - 0.5) * 3).toFixed(2) + 'deg');
      }

      karte.addEventListener('pointermove', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        mx = e.clientX; my = e.clientY;
        if (!laeuft) { laeuft = true; requestAnimationFrame(zeichnen); }
      });

      karte.addEventListener('pointerenter', function () { karte.classList.add('ist-nah'); });
      karte.addEventListener('pointerleave', function () {
        karte.classList.remove('ist-nah');
        karte.style.removeProperty('--ol-kipp-x');
        karte.style.removeProperty('--ol-kipp-y');
      });
    });
  }

  /* ------------------------------------------------------------------ 3
     Wellenschlag. Ein kurzlebiges <span> an der Klickstelle; es raeumt
     sich selbst weg. Nur auf den grossen Schaltflaechen, sonst wird es
     zum Jahrmarkt. */
  if (!ruhig) {
    document.addEventListener('pointerdown', function (e) {
      var knopf = e.target.closest && e.target.closest(
        '.bsfa-kat__knopf, .ol-finder__karte-knopf, .ol-an__knopf, .ol-wr__knopf, button[name="add"], .button--primary');
      if (!knopf || knopf.disabled) return;
      var r = knopf.getBoundingClientRect();
      var welle = document.createElement('span');
      welle.className = 'ol-glanz__welle';
      var gr = Math.max(r.width, r.height) * 2;
      welle.style.width = welle.style.height = gr + 'px';
      welle.style.left = (e.clientX - r.left - gr / 2) + 'px';
      welle.style.top = (e.clientY - r.top - gr / 2) + 'px';
      if (getComputedStyle(knopf).position === 'static') knopf.style.position = 'relative';
      knopf.appendChild(welle);
      setTimeout(function () { if (welle.parentNode) welle.parentNode.removeChild(welle); }, 620);
    }, { passive: true });
  }

  /* ------------------------------------------------------------------ 4
     Der Reitertitel, wenn der Besucher weggeklickt hat. Kein Blinken,
     kein Zaehler - eine ruhige Zeile, und beim Zurueckkommen steht
     sofort wieder der richtige Titel da. */
  /* Der eigene Mauszeiger stand frueher hier: ein <div>, das bei jeder
     Mausbewegung nachgezogen wurde. Er ist ersatzlos verschwunden -
     nicht weil er ueberfluessig war, sondern weil ein gezeichneter
     Zeiger dieselbe Wirkung ohne eine Zeile JavaScript hat. Waehrend
     eines Seitenwechsels kommen keine Mausereignisse mehr an; ein
     nachgezogener Punkt bleibt dann stehen, ein Zeigerbild nicht.
     Die Form liegt jetzt in sections/ol-glanz.liquid als CSS-Regel.

  /* ------------------------------------------------------------------ 6
     Milchglas in der Kopfleiste. Canyon scrollt auf grossen Schirmen
     nicht das Dokument, sondern .page-wrapper - deshalb wird beides
     abgehorcht. Umgeschaltet wird nur, wenn sich der Zustand aendert. */
  (function () {
    var kopf = document.getElementById('header-group');
    if (!kopf) return;
    var behaelter = document.querySelector('.page-wrapper');
    var tief = false;

    function pruefen() {
      var y = (behaelter && behaelter.scrollTop) || window.scrollY || 0;
      var neu = y > 40;
      if (neu !== tief) { tief = neu; kopf.classList.toggle('ist-tief', neu); }
    }

    if (behaelter) behaelter.addEventListener('scroll', pruefen, { passive: true });
    window.addEventListener('scroll', pruefen, { passive: true });
    pruefen();
  })();

  /* ------------------------------------------------------------------ 7
     Ladebalken. Zwischen Klick und neuer Seite liegt bei einem Shop
     schnell eine halbe Sekunde, in der nichts passiert. Der Balken
     laeuft in dieser Zeit bis kurz vor das Ende und verschwindet mit
     der neuen Seite. Nur eigene Adressen, keine Downloads, keine neuen
     Reiter, keine Ankerspruenge. */
  (function () {
    var balken = null;

    function starten() {
      if (balken) return;
      balken = document.createElement('div');
      balken.className = 'ol-glanz__laden';
      document.body.appendChild(balken);
      requestAnimationFrame(function () { balken.classList.add('ist-unterwegs'); });
    }

    function aufraeumen() {
      if (!balken) return;
      balken.classList.add('ist-fertig');
      var weg = balken;
      balken = null;
      setTimeout(function () { if (weg.parentNode) weg.parentNode.removeChild(weg); }, 300);
    }

    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      if (a.target === '_blank' || a.hasAttribute('download')) return;
      var u;
      try { u = new URL(a.getAttribute('href'), location.href); } catch (err) { return; }
      if (u.origin !== location.origin) return;
      if (u.pathname === location.pathname && u.search === location.search) return;
      starten();
    }, true);

    window.addEventListener('pagehide', aufraeumen);
    window.addEventListener('pageshow', aufraeumen);
  })();
})();

